import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const MuiToggleSwitchWrapper = styled.div`
  .MuiSwitch-switchBase {
    color: ${COLORS.cirrus_toggle_disable};
  }
  .MuiSwitch-track {
    background-color: ${COLORS.cirrus_black3};
    width: 32px;
    height: 8px;
    border-radius: 8px;
  }

  .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
    background-color: ${COLORS.cirrus_black3};
  }

  .MuiSwitch-switchBase.Mui-checked {
    color: ${COLORS.cirrus_green1};
  }

  .MuiSwitch-thumb {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    transform: translateY(-2px);
  }
`;
